<div class="flex-row full column align-start position-relative p-24">
    <button type="button" class="btn p-0 color-secondary close-modal" (click)="closeDialog()">X</button>
    <div class="flex-row full column align-start row-gap-16">
        <h2 class="fs-22 fw-7 color-secondary">Trade Smart Account Details</h2>
        <div class="flex-row full column align-center border-primary border-light border-radius-8 p-15">
            <div class="color-primary">
                Visit -<a href="javascript:void(0)" class="hover-primary fw-7" (click)="goToLogin()">
                    https://swing.tradesmartonline.in/</a> >>
                Login with your TradeSmart Credentials >> Open the side menu >> go to APP CENTER >> Click on "Create new
                app" >> Enter the App name - Pickright >> Description - Trading >> Submit.
                You will get the following information - AppId + AppSecret + Pass Key (Enter the details and Submit)
            </div>
        </div>
        <form class="flex-row full column align-start row-gap-16" autocomplete="off" [formGroup]="tradeKeyForm"
            (ngSubmit)="onSubmitForm()">
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">UID</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="UID" formControlName="uid">
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">AppID</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="appId" formControlName="appId">
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">App Secret key</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="appSecretKey" formControlName="appSecretKey">
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">Pass Key</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="passKey" formControlName="passKey">
            </div>
            <button type="submit" class="btn btn-primary btn-large width-100-pr"
                [disabled]="tradeKeyForm.invalid">Submit</button>
        </form>
    </div>
</div>